import { z as s } from "zod";
import { T as r } from "./base-DFJERsUx.js";
import { stripUndefinedOnEncodeAsync as d } from "./utils.js";
const a = "!@#$%&*-", l = 8, D = 32, P = s.string().min(8).max(32).regex(
  new RegExp(
    `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${a}])[a-zA-Z\\d${a}]{${l},}$`
  ),
  "auth/weak-password"
), p = s.string().refine(async (t) => {
  const { getAlpha2Codes: e } = (await import("i18n-iso-countries")).default;
  return !!e()[t];
}), _ = s.codec(
  s.string().trim().refine(async (t) => {
    const { isPhoneValid: e } = await import("./phone-utils.js");
    return e(t);
  }),
  s.string(),
  {
    decode: async (t) => {
      const { formatPhone: e } = await import("./phone-utils.js");
      return e(t) ?? t;
    },
    encode: (t) => t
  }
), i = (t) => s.object({
  country_code: t,
  postal_code: s.string().trim().nonempty(),
  // The highest level sub-division in a country, which is usually a province, state,
  // or ISO-3166-2 subdivision.
  admin_area_1: s.string().trim(),
  // City
  admin_area_2: s.string().trim().nonempty(),
  address_line_1: s.string().trim().nonempty(),
  address_line_2: s.string().trim()
}), A = i(s.string()), y = i(p), o = (t, e) => s.object({
  ...t.shape,
  first_name: s.string().trim().nonempty(),
  last_name: s.string().trim().nonempty(),
  phone: s.string().trim().pipe(e.or(s.literal(""))),
  email: s.string().trim().pipe(s.email())
}), f = o(
  A,
  s.string().trim().nonempty()
), u = o(y, _), n = s.string().brand("UserId"), m = (t) => s.object({
  name: s.string().trim().nonempty(),
  band: s.string().trim(),
  address: t,
  deliveryAddress: t.nullable()
}), g = m(f), c = m(u), S = g.extend({
  id: n,
  email: s.email().optional(),
  updated: r,
  created: r
}), Z = Object.freeze({
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  country_code: "",
  postal_code: "",
  admin_area_1: "",
  admin_area_2: "",
  address_line_1: "",
  address_line_2: ""
}), w = Object.freeze({
  email: void 0,
  name: "",
  band: "",
  address: Z,
  deliveryAddress: null
}), C = s.tuple([
  n,
  d(c.partial())
]), R = s.tuple([
  n,
  d(c)
]), $ = s.tuple([n]), v = s.tuple([n]), O = (t) => {
  const e = t.data();
  return e.id = t.id, "name" in e || (e.name = `${e.first_name} ${e.last_name}`), "address" in e ? ("first_name" in e.address || (e.address.first_name = e.first_name), "last_name" in e.address || (e.address.last_name = e.last_name), "email" in e.address || (e.address.email = e.email), "phone" in e.address || (e.address.phone = e.phone)) : e.address = null, "deliveryAddress" in e || (e.deliveryAddress = null), (!("updated" in e) || !e.updated) && (e.updated = e.created), e;
};
export {
  y as AddressAsyncZ,
  A as AddressZ,
  D as PASSWORD_MAX,
  l as PASSWORD_MIN,
  a as PASSWORD_SPECIAL_CHARACTERS,
  P as PasswordZ,
  u as UserAddressAsyncZ,
  f as UserAddressZ,
  R as UserCreateZ,
  c as UserDataAsyncZ,
  g as UserDataZ,
  v as UserEraseZ,
  n as UserIdZ,
  $ as UserRemoveZ,
  C as UserUpdateZ,
  S as UserZ,
  Z as emptyAddress,
  w as emptyUser,
  O as userDocMapper
};
//# sourceMappingURL=user.js.map
